import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { useCity } from '../contexts/CityContext';

export function SplashPage() {
  const { selectedCity, cities, loading, error } = useCity();
  const navigate = useNavigate();

  // Se já tem cidade selecionada (ou a primeira foi auto-selecionada), navega automaticamente
  useEffect(() => {
    if (selectedCity && !loading) {
      const timer = setTimeout(() => navigate('/mapa'), 600);
      return () => clearTimeout(timer);
    }
  }, [selectedCity, loading, navigate]);

  const handleEnter = () => {
    if (selectedCity) navigate('/mapa');
  };

  const handleChangeCity = () => {
    navigate('/cidade');
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: 24,
      background: 'linear-gradient(180deg, var(--nc-bg) 0%, var(--nc-surface) 100%)'
    }}>
      <div className="nc-fade-in" style={{ textAlign: 'center', maxWidth: 320, width: '100%' }}>
        <div style={{ marginBottom: 32 }}>
          <Logo size={80} showText={false} />
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--nc-primary)', marginBottom: 6 }}>
          Nossa Cidade
        </h1>
        <p style={{ fontSize: 14, color: 'var(--nc-text-secondary)', marginBottom: 32 }}>
          Sua cidade. Tudo aqui.
        </p>

        {loading ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 24 }}>
            <div style={{
              width: 16, height: 16, border: '2px solid var(--nc-border)',
              borderTopColor: 'var(--nc-primary)', borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <span className="nc-body-sm">Carregando cidades...</span>
          </div>
        ) : error ? (
          <div style={{
            background: 'var(--nc-danger-soft)', borderRadius: 10, padding: 14,
            border: '1px solid var(--nc-danger-border)', marginBottom: 16, fontSize: 13, color: 'var(--nc-danger)'
          }}>
            {error}
          </div>
        ) : selectedCity ? (
          <div style={{
            background: 'var(--nc-surface)', borderRadius: 12, padding: 16,
            border: '1px solid var(--nc-border)', marginBottom: 16,
            boxShadow: 'var(--nc-shadow)'
          }}>
            <div className="nc-caption" style={{ marginBottom: 4 }}>Você está em:</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--nc-text)' }}>
              {selectedCity.name} / {selectedCity.state}
            </div>
          </div>
        ) : cities.length === 0 ? (
          <div style={{
            background: 'var(--nc-surface)', borderRadius: 12, padding: 16,
            border: '1px solid var(--nc-border)', marginBottom: 16
          }}>
            <div style={{ fontSize: 14, color: 'var(--nc-text-secondary)' }}>
              Nenhuma cidade disponível no momento.
            </div>
          </div>
        ) : null}

        <button
          onClick={handleEnter}
          disabled={!selectedCity}
          className="nc-btn-primary"
          style={{ width: '100%', marginBottom: 10, opacity: selectedCity ? 1 : 0.5 }}
        >
          {selectedCity ? 'Entrar na cidade' : 'Aguarde...'}
        </button>

        <button
          onClick={handleChangeCity}
          className="nc-btn-outline"
          style={{ width: '100%' }}
        >
          Escolher outra cidade
        </button>

        <p className="nc-caption" style={{ marginTop: 20 }}>
          Sua cidade ainda não faz parte? <a href="#solicitar" style={{ color: 'var(--nc-primary)', fontWeight: 500, textDecoration: 'none' }}>Solicitar implantação</a>
        </p>
      </div>
    </div>
  );
}
